import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=73ca4bc7&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=73ca4bc7&prod&scoped=true&lang=less"
import style1 from "./Information.vue?vue&type=style&index=1&id=73ca4bc7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca4bc7",
  null
  
)

export default component.exports